import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import Button from "material-ui/Button";
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

const styles = () => ({
  root: {
    width: "100%",
    background: "#FFFFFF",
    border: "1px solid #E7E9EB",
    borderRadius: "2px",
    opacity: 1,
    padding: "40px 44px",
    boxSizing: "border-box",
    marginTop: "25px",
    position: "relative",
    minHeight: "200px",
  },

  sectionTitle: {
    fontWeight: "bold",
    marginBottom: "36px",
  },

  field: {
    marginBottom: "36px",
  },

  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginBottom: "24px",
  },

  settingButton: {
    color: "#1A65FF",
    fontSize: "13px",
    fontWeight: "bold",
    minWidth: "unset",
    minHeight: "unset",
    justifyContent: "center",
    alignItems: "center",
    padding: "1px",
    marginLeft: "18px",
  },
});

/**
 * Salesforce連携設定の結果を表示するコンポーネント
 */
class SalesforceIntegrateResult extends React.Component {
  render() {
    const { classes, salesforceSettingDirectory } = this.props;

    return (
      <div className={classes.root}>
        <Typography
          variant="display1"
          className={classes.sectionTitle}
          style={{ marginBottom: "48px" }}
        >
          {salesforceSettingDirectory.text}連携設定
        </Typography>

        <div className={classes.field}>
          <div className={classes.row}>
            <Typography
              variant="title"
              className={classes.sectionTitle}
              style={{ marginBottom: "0px" }}
            >
              Salesforceオブジェクト
            </Typography>
          </div>
          <Typography
            variant="subheading"
          >
            {this.props.sobjectName}
          </Typography>
        </div>

        <div className={classes.field}>
          <div className={classes.row}>
            <Typography
              variant="title"
              className={classes.sectionTitle}
              style={{ marginBottom: "0px" }}
            >
              項目マッピング
            </Typography>
            <Button
              color="primary"
              className={classes.settingButton}
              onClick={() =>
                this.props.goTo(salesforceSettingDirectory.setting_edit_path)
              }
            >
              設定する
            </Button>
          </div>
          <Typography
            variant="body2"
            style={{ marginBottom: "43px" }}
          >
            {salesforceSettingDirectory.setting_desc}
          </Typography>
          {this.props.children}
        </div>
      </div>
    );
  }
}

SalesforceIntegrateResult.propTypes = {
  classes: PropTypes.object.isRequired,
  salesforceSettingDirectory: PropTypes.object,
  sobjectName: PropTypes.string,
  goTo: PropTypes.func,
  children: PropTypes.node,
};

// @see 空を返してますが、エラーが発生するのでmapStateToPropsにconnectする必要があります。
const mapStateToProps = () => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    goTo(url, state) {
      dispatch(push(url, state));
    },
  };
};

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps
)(SalesforceIntegrateResult));



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/common/SalesforceIntegrateResult.jsx